import { executeGetRequest } from "@api/client";
import { apiPath } from "@routes/api";

export const getMembers = async (lang: string) => {
  const [promise] = executeGetRequest(apiPath.members, lang);
  const result: any = await promise;
  return result.data;
};
